export default "__VITE_ASSET__DyR5Cuj7__"